<template>
  <div>
    <!-- <Top></Top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img v-lazy="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">智慧影院</div>
          <div class="contentBottom">
            <div>智慧化影院建设,通过数据对接实现智能化业务服务</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <!-- start -->
    <div class="titleBox">
      <div class="anliTitle">方案价值</div>
      <div class="lineCss"></div>
    </div>
    <div
      class="contentTextOne"
    >分析消费者动线及影院的业务范畴，通过数据打通，智能交互等方式，提升消费者在影院逗留时间，增加消费者与影院产品、服务的互动，在提升消费者体验同时，融入营销，为影厅提升额外增值点。</div>
    <div class="planValue">
       <!-- start -->
       <div class="planValueTu">
        <div class="planValueLeft">
          <img v-lazy="valueLeft" alt class="valueLeft">
        </div>
        <div class="planValueRight">
          <img v-lazy="valueRight" alt class="valueLeft">
        </div>
      </div>
      <!-- end -->
    </div>
    <!-- end -->
    <!-- start -->
    <div class="changJing">
      <div class="titleBox">
        <div class="anliTitle" style="margin-top:118px">场景应用</div>
        <div class="lineCss"></div>
      </div>
      <!-- 场景box start -->
      <div class="reChangJingParent">
        <div class="reChangJingLeft">
          <img v-lazy="boxImg1" alt class="reImgCss">
          <!-- <div class="reImgText">云拼接影讯屏</div> -->
        </div>
        <div class="reChangJingRight">
          <img v-lazy="boxImg2" alt class="reImgCss">
          <!-- <div class="reImgText">云拼接广告屏 智能排片屏</div> -->
        </div>
        <div class="reChangJingLeft">
          <img v-lazy="boxImg3" alt class="reImgCss">
          <!-- <div class="reImgText">检票/影厅入口-卖品售卖屏</div> -->
        </div>
        <div class="reChangJingRight">
          <img v-lazy="boxImg4" alt class="reImgCss">
          <!-- <div class="reImgText">观影厅-影前互动广告</div> -->
        </div>
        <div class="reChangJingLeft">
          <img v-lazy="boxImg5" alt class="reImgCss">
          <!-- <div class="reImgText">大厅/走廊——衍生品货架</div> -->
        </div>
        <div class="reChangJingRight">
          <img v-lazy="boxImg6" alt class="reImgCss">
          <!-- <div class="reImgText">互动体验屏</div> -->
        </div>
      </div>
      <!-- 场景box end -->
    </div>
    <!-- end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:118px">实施方案</div>
      <div class="lineCss"></div>
    </div>
    <!-- bottom start -->
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomTitle">有屏门店</div>
        <img v-lazy="planLeftImg" alt>
        <div class="imgBottomTitle">原屏幕+数拓盒子</div>
        <div class="imgBottomText">
          通过HDMI线，让屏幕接入数拓智能盒子，联网后即可接入数拓云服务。
        </div>
        <div class="imgBottomFlex">
          <div class="imgBottomBox">
            <img v-lazy="rev5" alt>
            <div class="v5Css">V5</div>
          </div>
          <div class="imgBottomBox">
            <img v-lazy="rev5" alt>
            <div class="v5Css">V8</div>
          </div>
        </div>
      </div>
      <div class="bottomRight">
        <div class="bottomTitle">无屏门店</div>
        <img v-lazy="planRightImg" alt>
        <div class="imgBottomTitle">数拓商显一体机</div>
        <div class="imgBottomText">
          内置数拓智能播放系统，只需接电、联网，即可接入数拓云服务。
        </div>
        <div class="imgBottomFlex">
          <div class="imgBottomBox">
            <img v-lazy="reYiTi" alt>
            <div class="v5Css">一体机</div>
          </div>
          <div class="imgBottomBox">
            <img v-lazy="rePinJie" alt>
            <div class="v5Css">拼接屏</div>
          </div>
          <div class="imgBottomBox">
            <img v-lazy="led" alt>
            <div class="v5Css">LED</div>
          </div>
        </div>
      </div>
    </div>
    <!-- bottom end -->
    <!-- start -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:134px">典型案例</div>
      <div class="lineCss"></div>
    </div>
    <div class="anLiFlex">
      <div class="anLiBox">
        <img v-lazy="anLiBoxImg1" class="anLiBigImg" alt>
          <img v-lazy="cinemaPosition1" class="positionText" alt>
      </div>
      <div class="anLiBox">
        <img v-lazy="anLiBoxImg2" class="anLiBigImg" alt>
         <img v-lazy="cinemaPosition2" class="positionText" alt>
      </div>
      <div class="anLiBox">
        <img v-lazy="anLiBoxImg3" class="anLiBigImg" alt>
         <img v-lazy="cinemaPosition3" class="positionText" alt>
      </div>
      <div class="anLiBox">
        <img v-lazy="anLiBoxImg4" class="anLiBigImg" alt>
         <img v-lazy="cinemaPosition4" class="positionText" alt>
      </div>
    </div>
    <!-- end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/cinemaTop.png";
import valueLeft from "@/assets/images/cinemaPlanLeftFu.png";
import valueRight from "@/assets/images/cinemaPlanRight.png";
import valueRight1 from "@/assets/images/valueRight1.png";
import valueRight2 from "@/assets/images/valueRight2.png";
import valueRight3 from "@/assets/images/valueRight3.png";
import valueRight4 from "@/assets/images/valueRight4.png";
import valueRight5 from "@/assets/images/valueRight5.png";
import valueRight6 from "@/assets/images/valueRight6.png";
import boxImg1 from "@/assets/images/reChangJing1.png";
import boxImg2 from "@/assets/images/reChangJing2.png";
import boxImg3 from "@/assets/images/reChangJing3.png";
import boxImg4 from "@/assets/images/reChangJing4.png";
import boxImg5 from "@/assets/images/reChangJing5.png";
import boxImg6 from "@/assets/images/reChangJing6.png";
import planLeftImg from "@/assets/images/planLeftImg.png";
import planRightImg from "@/assets/images/planRightImg.png";
import bottomIcon1 from "@/assets/images/bottomIcon1.png";
import rev5 from "@/assets/images/rev5.png";
import reYiTi from "@/assets/images/reYiTi.png";
import rePinJie from "@/assets/images/rePinJie.png";
import led from "@/assets/images/led.png";
import anLiBoxImg1 from "@/assets/images/cinemaBottom1.png";
import anLiBoxImg2 from "@/assets/images/cinemaBottom2.png";
import anLiBoxImg3 from "@/assets/images/cinemaBottom3.png";
import anLiBoxImg4 from "@/assets/images/cinemaBottom4.png";
import cinemaPosition1 from "@/assets/images/cinemaPosition1.png";
import cinemaPosition2 from "@/assets/images/cinemaPosition2.png";
import cinemaPosition3 from "@/assets/images/cinemaPosition3.png";
import cinemaPosition4 from "@/assets/images/cinemaPosition4.png";
import Bread from "@/components/bread.vue";

export default {
  name: "PlanCinemaDetail",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      cinemaPosition1: cinemaPosition1,
      cinemaPosition2: cinemaPosition2,
      cinemaPosition3: cinemaPosition3,
      cinemaPosition4: cinemaPosition4,
      reYiTi: reYiTi,
      rev5: rev5,
      rePinJie: rePinJie,
      led: led,
      toBreadChild: ["方案", "智慧影院"],
      bgImg: bgImg,
       valueLeft: valueLeft,
      valueRight: valueRight,
      valueRight1: valueRight1,
      valueRight2: valueRight2,
      valueRight3: valueRight3,
      valueRight4: valueRight4,
      valueRight5: valueRight5,
      valueRight6: valueRight6,
      boxImg1: boxImg1,
      boxImg2: boxImg2,
      boxImg3: boxImg3,
      boxImg4: boxImg4,
      boxImg5: boxImg5,
      boxImg6: boxImg6,
      boxImg4: boxImg4,
      planLeftImg: planLeftImg,
      planRightImg: planRightImg,
      bottomIcon1: bottomIcon1,
      anLiBoxImg1: anLiBoxImg1,
      anLiBoxImg2: anLiBoxImg2,
      anLiBoxImg3: anLiBoxImg3,
      anLiBoxImg4: anLiBoxImg4
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* start */
.anliTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 100px;
}

/* end */
.contentTextOne {
  font-size: 2.4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
  width: 70%;
  margin: auto;
  max-width: 1010px;
  margin-top: 82px;
  /* text-indent: 2em; */
  text-align: center;
}

.planValue {
  background: rgba(240, 240, 240, 1);
}

.paddingTop87 {
  padding-top: 87px;
}

.planValueTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 73px;
  text-align: center;
  margin-top: 59px;
}

.planValueTu::after {
  content: "";
  display: block;
  clear: both;
}

.planValueTu {
  width: 70%;
  margin: auto;
  margin-top: 89px;
  padding: 80px 0;
}

.planValueLeft {
  width: 49%;
  float: left;
  background: #fff;
}

.planValueRight {
  width: 49%;
  float: right;
  background: #fff;
}

.lineBottom {
  height: 1px;
  background: rgba(240, 240, 240, 1);
}

.lineBottom {
  margin-top: 54px;
  margin-bottom: 36px;
}

.valueContent {
  padding: 0 30px;
  display: flex;
}

.yellowIcon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: rgba(252, 200, 0, 1);
}

.blackIcon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: rgba(49, 49, 49, 1);
}

.yellowRightFont {
  font-size: 1.8rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.valueContentTwo {
  padding: 0 30px;
}

.valueLeft {
  vertical-align: top;
  width: 100%;
}

.valueFlex {
  display: flex;
  justify-content: space-around;
}

.valueFlexBox {
  text-align: center;
  width: 33%;
  font-size: 1.6rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(0, 0, 0, 1);
  line-height: 24px;
}

.valueFlexBox img {
  margin: 99px 0 30px;
}

.valueBottomFlex {
  display: flex;
  margin-bottom: 55px;
  width: 83%;
  margin: auto;
}

.valueBottomBox {
  font-size: 1.6rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(0, 0, 0, 1);
  line-height: 24px;
  width: 20%;
  text-align: center;
}

.toRightIcon {
  color: #fcc800;
}

.boxTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 73px;
  margin-top: 75px;
  margin-bottom: 68px;
}

.marginTop89 {
  margin-top: 89px;
}

.bottomTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 73px;
  margin: 70px 0 113px;
}

.bottomParent::after {
  content: "";
  display: block;
  clear: both;
}

.bottomParent {
  width: 70%;
   min-width: 810px;
  margin: auto;
  margin-top: 86px;
  text-align: center;
}

.bottomLeft {
  width: 49%;
  float: left;
  border: 1px solid rgba(191, 191, 191, 1);
  height: 1065px;
}

.bottomRight {
  width: 49%;
  float: right;
  background: rgba(240, 240, 240, 1);
  height: 1065px;
}

.bottomRight img {
  max-height: 139px;
}

.imgBottomTitle {
  font-size: 2.4rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 39px;
  margin: 154px 0 56px;
}

.imgBottomText {
  width: 80%;
  margin: auto;
  font-size: 2.4rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 39px;
}

.imgBottomFlex {
  display: flex;
  width: 60%;
  margin: auto;
}

.imgBottomBox {
  flex-grow: 1;
}

.imgBottomBox img {
  margin: 103px 0 10px;
}

.v5Css {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.anLiFlex {
  display: flex;
  width: 70%;
  margin: auto;
  justify-content: space-around;
  margin-top: 85px;
}

.anLiBox {
  position: relative;
  width: 24%;
}

.positionText {
  position: absolute;
 
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  font-size: 2.4rem;
  font-family: PingFangSC-Medium;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 39px;
}

.contentBgImg {
  width: 100%;
}

.tabBoxParent {
  width: 80%;
  max-width: 1205px;
  position: relative;
  margin: auto;
}

.tabFlex {
  width: 100%;
  max-width: 1205px;
  margin: auto;
  display: flex;
  position: absolute;
  bottom: 7px;
  left: calc(50% - 50%);
}

.tabBox {
  flex-grow: 1;
  text-align: center;
  font-size: 2.4rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 39px;
  position: relative;
}

.tobLineImgCss {
  position: absolute;
  right: 0;
  bottom: 2px;
}

.tabBoxText {
  margin-bottom: 20px;
  transition: 0.5s;
}

.tabBoxText:hover {
  color: #fcc800;
}
.reChangJingParent {
  width: 70%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
}
.reChangJingParent::after {
  content: "";
  display: block;
  clear: both;
}
.reChangJingParent {
  margin-top: 77px;
}
.reChangJingLeft {
  width: 49%;
  float: left;
  margin-top: 20px;

}
.reChangJingRight {
  width: 49%;
  float: right;
  margin-top: 20px;
}
.reImgCss {
  width: 95%;
  /* max-width: 560px; */
}
.reImgText {
  text-align: center;
  font-size: 2.4rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 73px;
}
.anLiBigImg {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/PlanCinemaDetail.vue